import { render, staticRenderFns } from "./AdminEmails.vue?vue&type=template&id=9b975a18&scoped=true"
import script from "./AdminEmails.vue?vue&type=script&lang=js"
export * from "./AdminEmails.vue?vue&type=script&lang=js"
import style0 from "./AdminEmails.vue?vue&type=style&index=0&id=9b975a18&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b975a18",
  null
  
)

export default component.exports